import PhotoPickerMultipleModal from './SubComponent/MultipleFiles/PhotoPickerMultipleModal';
import PhotoPickerMultiple from './SubComponent/MultipleFiles/PhotoPickerMultiple';
import { FILE_TYPE } from '../../Helpers/fileType';

/**
 * Component for selecting or taking multiple photos. It includes the following validation:
        - If it is being used inside a modal, the video stream will be displayed in a separate modal.
        - If it is being used in the main view, all elements remain within the main view.

 *
 * @Author: Cecilia López Martínez
 * @JobTitle : Full Stack Developer - IBL
 * @Email : clopez@ibl.mx
 *
 * @param string id: component identifier
 * @param model accept: file formats and sizes accepted by the component
 * @param model photoPickerFile: component model
 * @param useState setPhotoPickerFile: state to update the component model
 * @param string titleInput: title of the dashed-line component (file selection)
 * @param boolean required:  default value is false, must be set to true if the field is required
 * @param boolean disabled: for the disabled component
 * @param boolean showBtnCamera: default value is false, must be set to true if the camera option is needed
 * @param boolean validateFace: default value is false, must be set to true if face validation is required
 * @param string inputContainerClass: custom class name applied to the input container for styling purposes
 * @param boolean emptyFields: default value is false
 * @param showBtnDeleteItemGallery: If true, the delete icon is displayed in the file gallery (FilesGallerySummary).
 * @param inModal: Indicates whether the component is being used in a modal; if so, the camera component will be displayed in a separate modal
 * @param setDisplayModal: Required when used inside a modal
 * @param titleWebcam: Title displayed when the camera video stream is active
 * @param titlePreviewWebcam: Title shown after a photo is taken, along with informational text in the preview of the captured image
 * @param titleModalCamera: Title used for the modal where the camera component is displayed
 *  @param {React.ComponentType|JSX.Element|null} [deleteIcon=null] - Custom icon component used for deleting files.
 * @param {React.ComponentType|JSX.Element|null} [downloadIcon=null] - Custom icon component used for downloading files.
 * @param {boolean} [showBtnDownload=true] - If true, shows the download icon for available files.
 */
const CustomPhotoPickerMultiple = (
    {
        id = 'fp_cppm_add_files_upload_multiple',
        accept = FILE_TYPE.IMAGE,
        photoPickerFile,
        setPhotoPickerFile,
        titleInput = 'drag_your_file_or',
        required = false,
        disabled = false,
        showBtnCamera = true,
        validateFace = false,
        inputContainerClass = '', // Custom class name applied to the input container for styling purposes
        emptyFields = false,
        showBtnDeleteItemGallery = true, // If true, the delete icon is displayed in the file gallery (FilesGallerySummary).
        inModal = false, // Indicates whether the component is being used in a modal; if so, the camera component will be displayed in a separate modal
        setDisplayModal = null, // Required when used inside a modal
        titleWebcam = '', // Title displayed when the camera video stream is active
        titlePreviewWebcam = '', // Title shown after a photo is taken, along with informational text in the preview of the captured image
        titleModalCamera = 'take_photography', // Title used for the modal where the camera component is displayed
        deleteIcon = null,
        downloadIcon = null,
        showBtnDownload = false,
        apiDelete= true
    }
) => {

    return (
        <>
            {inModal
                ?
                <PhotoPickerMultipleModal
                    id={id}
                    accept={accept}
                    photoPickerFile={photoPickerFile}
                    setPhotoPickerFile={setPhotoPickerFile}
                    titleInput={titleInput}
                    required={required}
                    disabled={disabled}
                    showBtnCamera={showBtnCamera}
                    validateFace={validateFace}
                    inputContainerClass={inputContainerClass}
                    emptyFields={emptyFields}
                    showBtnDeleteItemGallery={showBtnDeleteItemGallery}
                    setDisplayModal={setDisplayModal}
                    titleWebcam={titleWebcam}
                    titlePreviewWebcam={titlePreviewWebcam}
                    titleModalCamera={titleModalCamera}
                />
                :
                <PhotoPickerMultiple
                    id={id}
                    accept={accept}
                    photoPickerFile={photoPickerFile}
                    setPhotoPickerFile={setPhotoPickerFile}
                    titleInput={titleInput}
                    required={required}
                    disabled={disabled}
                    showBtnCamera={showBtnCamera}
                    validateFace={validateFace}
                    inputContainerClass={inputContainerClass}
                    emptyFields={emptyFields}
                    showBtnDeleteItemGallery={showBtnDeleteItemGallery}
                    titleWebcam={titleWebcam}
                    titlePreviewWebcam={titlePreviewWebcam}
                    deleteIcon={deleteIcon}
                    downloadIcon={downloadIcon}
                    showBtnDownload={showBtnDownload}
                    apiDelete={apiDelete}
                />
            }
        </>
    )

}

export default CustomPhotoPickerMultiple
